import { render } from "./otp.vue?vue&type=template&id=98e9d5de&scoped=true"
import script from "./otp.vue?vue&type=script&lang=js"
export * from "./otp.vue?vue&type=script&lang=js"

import "./otp.vue?vue&type=style&index=0&id=98e9d5de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e9d5de"]])

export default __exports__